/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';

/**
 * GetCmsListContentPodcast Input Action
 */
export class GetCmsListContentPodcastInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CMS_LIST_CONTENT_PODCAST`;
    public getCacheObjectType = () => 'CMS_LIST_CONTENT_PODCAST';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetCmsListContentPodcastData {
    totalItem: any;
    dataCms: AttributeValue[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCmsListContentPodcastInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetCmsListContentPodcastInput, ctx: Msdyn365.IActionContext): Promise<IGetCmsListContentPodcastData | null> {
    let pageID: string = '';
    let pathName: string = '';
    let searchParam: string = '';
    if (ctx && ctx.requestContext && ctx.requestContext.url && ctx.requestContext.url.requestUrl) {
        pathName = ctx.requestContext.url.requestUrl.pathname;
        const pieces = pathName.split(/[\s\/]+/);
        pageID = pieces[pieces.length - 1];
        searchParam = ctx.requestContext.url.requestUrl.search;
    }
    if (pageID !== '') {
        const frontApiEndpoint = ctx.requestContext.app.config.cmsAPIEndpoint && ctx.requestContext.app.config.cmsAPIEndpoint;
        // const frontApiEndpoint = 'http://herbal-cms.localhost:8001';
        const requestUrl = `${frontApiEndpoint}/api/list/node--${pageID}/en${searchParam}`;

        const result = await Msdyn365.sendRequest<IGetCmsListContentPodcastData>(requestUrl, 'get')
            .then(response => {
                return response.data;
            })
            .catch(error => {
                ctx.trace('[GetCmsListPodcastContent] Failed to get list data podcast.');
                throw error;
            });

        return result;
    }

    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCmsListContentPodcastData>>action,
    // TODO: Give your data action a unique id
    id: 'GetCmsListPodcastContent',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
